import React, { useRef, useCallback, useEffect, useState } from "react";

const SiteMapViewer = ({ fechaSeleccionada, siteMap, onAsientoSelect, asientosSeleccionados = [], entradas = [], reportes = [] }) => {
  const canvasRef = useRef(null);
  const [ctx, setCtx] = useState(null);
  const [asientosVendidos, setAsientosVendidos] = useState(new Set());

  // Estados para zoom y pan
  const [scale, setScale] = useState(1);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [hasMoved, setHasMoved] = useState(false);

  // Procesar reportes para identificar asientos vendidos
  useEffect(() => {
    console.log("=== USEEFFECT REPORTES EJECUTÁNDOSE ===");
    console.log("Reportes recibidos:", reportes);
    console.log("Tipo de reportes:", typeof reportes);
    console.log("Es array?:", Array.isArray(reportes));
    console.log("Longitud:", reportes?.length);
    console.log("Fecha seleccionada:", fechaSeleccionada);

    if (!reportes || reportes.length === 0) {
      console.log("❌ No hay reportes para procesar - limpiando vendidos");
      setAsientosVendidos(new Set());
      return;
    }

    console.log("✅ Iniciando procesamiento de reportes");
    const vendidos = new Set();

    reportes.forEach((reporte, idx) => {
      console.log(`\n--- Procesando reporte ${idx} ---`);
      console.log("Reporte completo:", reporte);
      console.log("entradas_id:", reporte.entradas_id);
      console.log("fecha del reporte:", reporte.fecha);
      console.log("reporte_codigo:", reporte.reporte_codigo);
      console.log("Tipo de reporte_codigo:", typeof reporte.reporte_codigo);
      console.log("Es array reporte_codigo?:", Array.isArray(reporte.reporte_codigo));

      // El reporte tiene:
      // - entradas_id: el id del sector (entrada)
      // - fecha: fecha del reporte
      // - reporte_codigo: puede ser string JSON o array con objetos que tienen sector_numero (id del asiento)

      let codigos = reporte.reporte_codigo;

      // Si viene como string JSON, parsearlo
      if (typeof codigos === 'string') {
        try {
          codigos = JSON.parse(codigos);
          console.log("reporte_codigo parseado:", codigos);
        } catch (e) {
          console.error("Error al parsear reporte_codigo:", e);
          return;
        }
      }

      if (codigos && Array.isArray(codigos)) {
        codigos.forEach((codigo, cidx) => {
          console.log(`  Código[${cidx}]:`, codigo);
          console.log(`  sector_numero:`, codigo.sector_numero);
          console.log(`  Comparando fechas: "${reporte.fecha}" == "${fechaSeleccionada}"?`, reporte.fecha == fechaSeleccionada);

          if (codigo.sector_numero && reporte.fecha == fechaSeleccionada) {
            // Convertir a number si viene como string, o usar directamente
            const asientoId = codigo.sector_numero;
            vendidos.add(asientoId);
            console.log(`  ✅ Asiento vendido agregado - ID: ${asientoId} (tipo original: ${typeof codigo.sector_numero}), Sector: ${reporte.entradas_id}`);
          } else {
            if (!codigo.sector_numero) {
              console.log(`  ⚠️ sector_numero vacío o inválido`);
            }
            if (reporte.fecha != fechaSeleccionada) {
              console.log(`  ⚠️ Fecha no coincide - ignorando`);
            }
          }
        });
      } else {
        console.log("❌ reporte_codigo no es un array válido");
      }
    });

    console.log(`\n=== RESUMEN ===`);
    console.log(`Total de asientos vendidos: ${vendidos.size}`);
    console.log("IDs de asientos vendidos:", Array.from(vendidos));
    setAsientosVendidos(vendidos);
  }, [reportes, fechaSeleccionada]);

  // Callback ref para inicializar el canvas
  const canvasCallbackRef = useCallback((canvas) => {
    if (canvas) {
      canvasRef.current = canvas;
      const context = canvas.getContext("2d");

      // Ajustar tamaño
      canvas.width = 800;
      canvas.height = 600;

      // Dibujar fondo
      context.fillStyle = "#FFFFFF";
      context.fillRect(0, 0, canvas.width, canvas.height);

      setCtx(context);
    }
  }, []);

  // Función para dibujar el mapa
  const dibujarMapa = useCallback(() => {
    if (!ctx || !canvasRef.current || !siteMap) {
      return;
    }

    const canvas = canvasRef.current;

    try {
      // Limpiar canvas
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Aplicar transformación de zoom y pan
      ctx.save();
      ctx.translate(offsetX, offsetY);
      ctx.scale(scale, scale);

      // Dibujar escenario si existe
      if (siteMap.escenario) {
        ctx.save();
        ctx.fillStyle = "#2C3E50";
        ctx.strokeStyle = "#34495E";
        ctx.lineWidth = 3;

        const escenario = siteMap.escenario;
        if (escenario.tipo === "semicircular") {
          ctx.beginPath();
          ctx.arc(
            escenario.x + escenario.width / 2,
            escenario.y + escenario.height,
            escenario.width / 2,
            Math.PI,
            0,
            false
          );
          ctx.closePath();
          ctx.fill();
          ctx.stroke();
        } else {
          ctx.fillRect(escenario.x, escenario.y, escenario.width, escenario.height);
          ctx.strokeRect(escenario.x, escenario.y, escenario.width, escenario.height);
        }

        ctx.fillStyle = "#FFFFFF";
        ctx.font = "bold 14px Arial";
        ctx.textAlign = "center";
        ctx.fillText("ESCENARIO", escenario.x + escenario.width / 2, escenario.y + escenario.height / 2);

        ctx.restore();
      }

      // Dibujar elementos especiales (escaleras, salidas, etc.)
      if (siteMap.elementosEspeciales && siteMap.elementosEspeciales.length > 0) {
        console.log("Dibujando elementos especiales. Total:", siteMap.elementosEspeciales.length);

        siteMap.elementosEspeciales.forEach(elemento => {
          ctx.save();

          // Colores según tipo
          let color = "#666666";
          switch (elemento.tipo) {
            case "escalera":
              color = "#95A5A6";
              break;
            case "ingreso":
              color = "#27AE60";
              break;
            case "salida_emergencia":
              color = "#E74C3C";
              break;
            case "baño":
              color = "#3498DB";
              break;
            case "pasillo":
              color = "#BDC3C7";
              break;
            default:
              color = "#7F8C8D";
          }

          ctx.fillStyle = color;
          ctx.strokeStyle = "#34495E";
          ctx.lineWidth = 2;

          // Dibujar rectángulo
          ctx.fillRect(elemento.x, elemento.y, elemento.width, elemento.height);
          ctx.strokeRect(elemento.x, elemento.y, elemento.width, elemento.height);

          // Calcular tamaño de fuente dinámico según el tamaño del elemento
          const padding = 10;
          const maxWidth = elemento.width - (padding * 2);
          const maxHeight = elemento.height - (padding * 2);

          // Texto a mostrar
          const texto = elemento.etiqueta || elemento.tipo.replace('_', ' ');

          // Calcular tamaño de fuente que quepa en el rectángulo
          let fontSize = Math.min(maxHeight * 0.8, maxWidth / (texto.length * 0.6));
          fontSize = Math.max(8, Math.min(fontSize, 20)); // Min 8px, Max 20px

          // Dibujar texto centrado
          ctx.fillStyle = "#FFFFFF";
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(
            texto.toUpperCase(),
            elemento.x + elemento.width / 2,
            elemento.y + elemento.height / 2
          );

          // Dibujar icono según tipo (opcional, solo si hay espacio)
          if (elemento.width > 40 && elemento.height > 40) {
            ctx.font = `${Math.min(fontSize * 1.5, 24)}px Arial`;
            let icono = "";
            switch (elemento.tipo) {
              case "escalera":
                icono = "≡";
                break;
              case "ingreso":
                icono = "→";
                break;
              case "salida_emergencia":
                icono = "⚠";
                break;
              case "baño":
                icono = "♿";
                break;
              case "pasillo":
                icono = "↕";
                break;
            }

            if (icono && elemento.height > 60) {
              ctx.fillText(icono, elemento.x + elemento.width / 2, elemento.y + elemento.height / 4);
            }
          }

          ctx.restore();
        });
      }

      // Dibujar asientos
      if (siteMap.asientos && siteMap.asientos.length > 0) {
        console.log("=== DIBUJANDO ASIENTOS ===");
        console.log("Total asientos:", siteMap.asientos.length);
        console.log("Asientos vendidos (Set):", Array.from(asientosVendidos));
        console.log("Entradas recibidas:", entradas);

        siteMap.asientos.forEach((asiento, index) => {
          // MOSTRAR TODOS LOS ASIENTOS de todos los sectores
          // No filtrar por entrada aquí

          ctx.save();

          // Buscar sector en el sitemap para obtener el color
          const sector = siteMap.sectores ? siteMap.sectores.find(s => s.id == asiento.sector_id) : null;

          // Verificar si el asiento está vendido según los reportes
          // asiento.id es el identificador único del asiento
          // Intentar comparar tanto con number como con string
          const asientoIdNum = typeof asiento.id === 'string' ? parseInt(asiento.id) : asiento.id;
          const estaVendido = asientosVendidos.has(asiento.id) || asientosVendidos.has(asientoIdNum) || asientosVendidos.has(String(asiento.id));

          // Log solo los primeros 5 asientos y los vendidos
          if (index < 5 || estaVendido) {
            console.log(`Asiento[${index}]: id=${asiento.id} (tipo: ${typeof asiento.id}), numero=${asiento.numero}, sector_id=${asiento.sector_id}, estado=${asiento.estado}, estaVendido=${estaVendido}`);
          }

          // Determinar color del asiento
          let color = sector ? sector.color : "#5B9BD5"; // Color del sector o azul por defecto

          if (asiento.estado === "vendido" || estaVendido) {
            color = "#DC3545"; // Vendido (rojo)
          } else if (asiento.estado === "reservado") {
            color = "#FFA500"; // Reservado (naranja)
          } else if (asientosSeleccionados.includes(asiento.id)) {
            color = "#28A745"; // Seleccionado (verde)
          }

          ctx.fillStyle = color;
          ctx.strokeStyle = "#FFFFFF";
          ctx.lineWidth = 1.5;

          // Dibujar butaca de teatro
          const w = asiento.width;
          const h = asiento.height;
          const x = asiento.x;
          const y = asiento.y;

          // Respaldo
          ctx.beginPath();
          ctx.moveTo(x + 2, y);
          ctx.lineTo(x + w - 2, y);
          ctx.arcTo(x + w, y, x + w, y + 2, 2);
          ctx.lineTo(x + w, y + h * 0.6);
          ctx.lineTo(x + w - 3, y + h * 0.6);
          ctx.lineTo(x + w - 3, y + 2);
          ctx.arcTo(x + w - 3, y, x + w - 5, y, 2);
          ctx.lineTo(x + 5, y);
          ctx.arcTo(x + 3, y, x + 3, y + 2, 2);
          ctx.lineTo(x + 3, y + h * 0.6);
          ctx.lineTo(x, y + h * 0.6);
          ctx.lineTo(x, y + 2);
          ctx.arcTo(x, y, x + 2, y, 2);
          ctx.closePath();
          ctx.fill();
          ctx.stroke();

          // Asiento (base)
          ctx.beginPath();
          ctx.moveTo(x + 2, y + h * 0.55);
          ctx.lineTo(x + w - 2, y + h * 0.55);
          ctx.lineTo(x + w - 2, y + h - 4);
          ctx.arcTo(x + w - 2, y + h, x + w - 6, y + h, 4);
          ctx.lineTo(x + 6, y + h);
          ctx.arcTo(x + 2, y + h, x + 2, y + h - 4, 4);
          ctx.closePath();

          const gradient = ctx.createLinearGradient(x, y + h * 0.55, x, y + h);
          gradient.addColorStop(0, color);
          gradient.addColorStop(1, shadeColor(color, -20));
          ctx.fillStyle = gradient;
          ctx.fill();
          ctx.strokeStyle = color;
          ctx.lineWidth = 1;
          ctx.stroke();

          // Número del asiento
          ctx.fillStyle = "#FFFFFF";
          ctx.font = "bold 8px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(asiento.numero, x + w / 2, y + h * 0.80);

          ctx.restore();
        });
      }

      // Función auxiliar para oscurecer colores
      function shadeColor(color, percent) {
        const num = parseInt(color.replace("#", ""), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = (num >> 8 & 0x00FF) + amt;
        const B = (num & 0x0000FF) + amt;
        return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
          (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
          (B < 255 ? B < 1 ? 0 : B : 255))
          .toString(16).slice(1);
      }

      // Restaurar transformación
      ctx.restore();
    } catch (error) {
      console.error("Error al dibujar el mapa:", error);
    }
  }, [ctx, siteMap, asientosSeleccionados, entradas, asientosVendidos, scale, offsetX, offsetY]);

  // Redibujar cuando cambian los datos
  useEffect(() => {
    if (ctx && siteMap) {
      dibujarMapa();
    }
  }, [ctx, siteMap, asientosSeleccionados, dibujarMapa]);

  // Manejo de zoom con rueda del mouse
  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.1 : 0.1;
    const newScale = Math.min(Math.max(0.5, scale + delta), 5); // Límite entre 0.5x y 5x
    setScale(newScale);
  };

  // Manejo de inicio de arrastre
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setHasMoved(false);
    setDragStart({
      x: e.clientX - offsetX,
      y: e.clientY - offsetY
    });
  };

  // Manejo de movimiento durante arrastre
  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const newX = e.clientX - dragStart.x;
    const newY = e.clientY - dragStart.y;

    // Detectar si realmente hubo movimiento
    if (Math.abs(newX - offsetX) > 2 || Math.abs(newY - offsetY) > 2) {
      setHasMoved(true);
    }

    setOffsetX(newX);
    setOffsetY(newY);
  };

  // Manejo de fin de arrastre
  const handleMouseUp = () => {
    setIsDragging(false);
    // No resetear hasMoved aquí, se resetea en handleCanvasClick
  };

  // Touch handlers para dispositivos móviles
  const [lastTouchDistance, setLastTouchDistance] = useState(null);

  const handleTouchStart = (e) => {
    if (e.touches.length === 2) {
      // Pinch zoom
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );
      setLastTouchDistance(distance);
      setHasMoved(true); // Pinch siempre cuenta como movimiento
    } else if (e.touches.length === 1) {
      // Pan
      setIsDragging(true);
      setHasMoved(false);
      setDragStart({
        x: e.touches[0].clientX - offsetX,
        y: e.touches[0].clientY - offsetY
      });
    }
  };

  const handleTouchMove = (e) => {
    if (e.touches.length === 2 && lastTouchDistance) {
      // Pinch zoom
      e.preventDefault();
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );
      const delta = (distance - lastTouchDistance) * 0.01;
      const newScale = Math.min(Math.max(0.5, scale + delta), 5);
      setScale(newScale);
      setLastTouchDistance(distance);
    } else if (e.touches.length === 1 && isDragging) {
      // Pan
      const newX = e.touches[0].clientX - dragStart.x;
      const newY = e.touches[0].clientY - dragStart.y;

      // Detectar si realmente hubo movimiento
      if (Math.abs(newX - offsetX) > 2 || Math.abs(newY - offsetY) > 2) {
        setHasMoved(true);
      }

      setOffsetX(newX);
      setOffsetY(newY);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    setLastTouchDistance(null);
  };

  // Reset zoom y pan
  const handleReset = () => {
    setScale(1);
    setOffsetX(0);
    setOffsetY(0);
  };

  // Manejo de click en el canvas
  const handleCanvasClick = (e) => {
    // Si hubo movimiento, no procesar como click
    if (hasMoved) {
      setHasMoved(false);
      return;
    }

    if (!siteMap || !siteMap.asientos) return;

    const rect = canvasRef.current.getBoundingClientRect();
    const scaleX = canvasRef.current.width / rect.width;
    const scaleY = canvasRef.current.height / rect.height;

    // Ajustar coordenadas por zoom y pan
    const canvasX = (e.clientX - rect.left) * scaleX;
    const canvasY = (e.clientY - rect.top) * scaleY;

    const x = (canvasX - offsetX) / scale;
    const y = (canvasY - offsetY) / scale;

    console.log("Click en canvas - x:", x, "y:", y);

    // Buscar asiento clickeado
    const asientoClickeado = siteMap.asientos.find(a => {
      const dentroDelAsiento = (
        x >= a.x &&
        x <= a.x + a.width &&
        y >= a.y &&
        y <= a.y + a.height
      );

      if (dentroDelAsiento) {
        console.log("Asiento encontrado:", a);
      }

      // Verificar si está vendido según reportes (comparar como number y string)
      const asientoIdNum = typeof a.id === 'string' ? parseInt(a.id) : a.id;
      const estaVendido = asientosVendidos.has(a.id) || asientosVendidos.has(asientoIdNum) || asientosVendidos.has(String(a.id));

      // Solo asientos disponibles (no vendidos, no reservados, no en estado vendido)
      return dentroDelAsiento && a.estado === "disponible" && !estaVendido;
    });

    if (asientoClickeado) {
      console.log("Asiento clickeado (disponible):", asientoClickeado);
      console.log("Entradas disponibles:", entradas);

      // Verificar si el sector del asiento pertenece a alguna entrada activa con sector
      const entradaDelSector = entradas.find(entrada => {
        console.log("Verificando entrada:", entrada.id, "contra sector_id:", asientoClickeado.sector_id);

        // Verificar diferentes formatos del campo sector
        const tieneSector = (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") ||
                           (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "");

        const esDelMismoSector = entrada.id == asientoClickeado.sector_id;

        console.log("Tiene sector:", tieneSector, "Es del mismo sector:", esDelMismoSector);

        return tieneSector && esDelMismoSector;
      });

      if (entradaDelSector && onAsientoSelect) {
        console.log("✅ Entrada del sector encontrada:", entradaDelSector);
        onAsientoSelect(asientoClickeado);
      } else {
        console.log("❌ No se encontró entrada para el sector_id:", asientoClickeado.sector_id);
        console.log("Todas las entradas:", entradas.map(e => ({ id: e.id, sector: e.sector })));
      }
    } else {
      console.log("No se encontró ningún asiento en la posición clickeada");
    }
  };

  return (
    <div className="border rounded bg-white p-2 shadow-sm">
      <div className="mb-2">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="fw-bold text-dark">
            <i className="bi bi-hand-index me-1"></i>
            Selecciona tus asientos
          </small>
          <div className="d-flex gap-1">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setScale(Math.min(5, scale + 0.2))}
              title="Acercar zoom"
            >
              <i className="bi bi-zoom-in"></i>
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setScale(Math.max(0.5, scale - 0.2))}
              title="Alejar zoom"
            >
              <i className="bi bi-zoom-out"></i>
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={handleReset}
              title="Resetear vista"
            >
              <i className="bi bi-arrow-clockwise"></i>
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="text-muted" style={{fontSize: '10px'}}>
            <i className="bi bi-info-circle me-1"></i>
            Usa la rueda del mouse o pellizca para zoom. Arrastra para mover.
          </small>
          <small className="badge bg-secondary" style={{fontSize: '9px'}}>
            Zoom: {(scale * 100).toFixed(0)}%
          </small>
        </div>
        <div className="d-flex flex-wrap gap-2 mb-2">
          <small className="d-flex align-items-center">
            <span className="badge rounded-circle me-1" style={{backgroundColor: "#5B9BD5", width: "12px", height: "12px"}}></span>
            Disponible
          </small>
          <small className="d-flex align-items-center">
            <span className="badge rounded-circle me-1" style={{backgroundColor: "#28A745", width: "12px", height: "12px"}}></span>
            Seleccionado
          </small>
          <small className="d-flex align-items-center">
            <span className="badge rounded-circle me-1" style={{backgroundColor: "#DC3545", width: "12px", height: "12px"}}></span>
            Vendido
          </small>
        </div>
        {siteMap?.elementosEspeciales && siteMap.elementosEspeciales.length > 0 && (
          <details className="mt-2">
            <summary className="small text-muted" style={{cursor: "pointer"}}>
              <i className="bi bi-info-circle me-1"></i>
              Referencias del mapa
            </summary>
            <div className="d-flex flex-wrap gap-2 mt-2">
              <small className="d-flex align-items-center">
                <span className="badge me-1" style={{backgroundColor: "#27AE60", fontSize: "8px"}}>→</span>
                Ingreso
              </small>
              <small className="d-flex align-items-center">
                <span className="badge me-1" style={{backgroundColor: "#E74C3C", fontSize: "8px"}}>⚠</span>
                Salida emerg.
              </small>
              <small className="d-flex align-items-center">
                <span className="badge me-1" style={{backgroundColor: "#95A5A6", fontSize: "8px"}}>≡</span>
                Escalera
              </small>
              <small className="d-flex align-items-center">
                <span className="badge me-1" style={{backgroundColor: "#3498DB", fontSize: "8px"}}>♿</span>
                Baño
              </small>
              <small className="d-flex align-items-center">
                <span className="badge me-1" style={{backgroundColor: "#BDC3C7", fontSize: "8px"}}>↕</span>
                Pasillo
              </small>
            </div>
          </details>
        )}
      </div>
      <canvas
        ref={canvasCallbackRef}
        onClick={handleCanvasClick}
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          cursor: isDragging ? 'grabbing' : 'grab',
          display: 'block',
          width: '100%',
          height: 'auto',
          backgroundColor: '#ffffff',
          borderRadius: '4px',
          touchAction: 'none'
        }}
      />
    </div>
  );
};

export default SiteMapViewer;
